import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { ButtonModel } from '@notino/react-styleguide';

import { skinAnalyserMessages } from '../messages';
import { StyledButton } from '../styled';

interface ActionButtonProps {
  onOpenSkinAnalyzer: () => void;
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  onOpenSkinAnalyzer,
}) => {
  return (
    <StyledButton
      onClick={onOpenSkinAnalyzer}
      fullWidth={true}
      buttonStyle={ButtonModel.Styles.secondary}
    >
      <FormattedMessage {...skinAnalyserMessages.skinAnalyserRunDiagnostic} />
    </StyledButton>
  );
};
